import type { ReportJSON } from '@aloft/toolkit-shared';
import { FormType } from '@aloft/toolkit-shared';

import { scalarToNumberToString } from '../utils.ts';
import { createNodeWithText } from './utils.ts';

export const generateTotalXmlAdjustmentNodes = (
  doc: XMLDocument,
  comp: ReportJSON['comps'][string],
  formType: FormType,
): HTMLElement[] => {
  const bathroomLineNodeID = formType === FormType.fnma1025 ? 'UN_NUM1_ADJ' : 'RM_TOTAL_ADJ';
  const grossAreaNodeID = formType === FormType.fnma1025 ? 'SF_GBA_ADJ' : 'SF_GLA_ADJ';
  const adjustmentNodes = [
    createNodeWithText(doc, 'PR_SALEPR1', comp.salesGridData.annotations.PropertySalesAmount),
    createNodeWithText(
      doc,
      'FN_CONC1_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.SalesConcessions),
    ),
    createNodeWithText(
      doc,
      'FN_CONC2_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.FinancingConcessions),
    ),
    createNodeWithText(
      doc,
      'DT_SALTIM1_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.DateOfSale),
    ),
    createNodeWithText(
      doc,
      'ST_SITSIZE_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.SiteArea),
    ),
    createNodeWithText(
      doc,
      'DA_CONSTQL_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.Quality),
    ),
    createNodeWithText(
      doc,
      'AG_COND1_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.Condition),
    ),
    createNodeWithText(doc, 'AG_AGYRBLT_ADJ', scalarToNumberToString(0)),
    createNodeWithText(
      doc,
      bathroomLineNodeID,
      scalarToNumberToString(comp.salesGridData.adjustments?.RoomAboveGradeLine2),
    ),
    createNodeWithText(
      doc,
      grossAreaNodeID,
      scalarToNumberToString(comp.salesGridData.adjustments?.GrossLivingArea),
    ),
    createNodeWithText(
      doc,
      'UN_NUM2_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.NumberOfUnits),
    ),
    createNodeWithText(
      doc,
      'BM_BSM1_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.BasementArea),
    ),
    createNodeWithText(
      doc,
      'BM_BSM2_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.BasementFinish),
    ),
    createNodeWithText(
      doc,
      'FU_FUNCTUT_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.FunctionalUtility),
    ),
    createNodeWithText(
      doc,
      'CR_GARPRK1_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.CarStorage),
    ),
    createNodeWithText(
      doc,
      'PF_PORPAT1_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.PorchDeck),
    ),
    createNodeWithText(doc, 'CM_OTHR1_TEXT', 'Add. Features'),
    createNodeWithText(
      doc,
      'BL_BLANK1_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.OtherFeature1),
    ),
    createNodeWithText(
      doc,
      'BL_BLANK2_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.OtherFeature2),
    ),
    createNodeWithText(
      doc,
      'BL_BLANK3_ADJ',
      scalarToNumberToString(comp.salesGridData.adjustments?.OtherFeature3),
    ),
  ];

  return adjustmentNodes;
};
